export const networking = {
  'QrBadge': 'QR Badge',
  'seeAll': 'Zobacz wszystko',
  'newcommers': 'New Networkers',
  'checkThemOut': 'Sprawdź ich!',
  'topicsToDiscuss': 'Tematy do dyskusji',
  'OneOnOneMeet': 'Spotkanie 1:1',
  'learnMoreNetworking': 'Dowiedz się więcej o Networking Hub',
  'scanQrCode': 'Skanuj kod QR',
  'myBadge': 'Mój badge',
  'message': 'Wiadomość',
  'scannedBadge': 'Zeskanowany badge',
  'viewProfile': 'Zobacz profil',
  'userRatingDetails': 'Szczegóły oceny użytkownika',
  'networkingHub': 'Networking Hub',
  'totalScore': 'Łączny wynik:',
  'scoreComposedOf': 'Ten wynik składa się z:',
  'confirmationText': 'Jesteś pewny? Tego nie można cofnąć.',

  'welcomeMessage': 'Witaj w <strong>Networking Hub</strong>, gdzie połączenia stają się żywe! Oto jak to działa:',
  'connectingMadeSimpleTitle': 'Łączenie stało się proste',
  'connectingMadeSimpleDescription':
    'Networking Hub oferuje strukturalne działania i poziomy, które pomagają ci skutecznie łączyć się:',

  'newcomersDescription':
    '<strong>Newcomers:</strong> Przeglądaj profile nowicjuszy, dodawaj interesujących do swojej krótkiej listy i wysyłaj wiadomości. Możesz także połączyć się z nimi osobiście.',
  'shortlistDescription': '<strong>Shortlist:</strong> Po pokazaniu zainteresowania kimś, zostają oni dodani do twojej listy.',
  'contactedConnectedDescription':
    '<strong>Contacted/Connected:</strong> Kiedy skontaktujesz się i otrzymasz odpowiedź, zostaną przeniesieni do tych kategorii.',
  'skipDescription': '<strong>Skip:</strong> Nie jesteś zainteresowany? Po prostu pomiń profil i przejdź dalej!',

  'enhancedNetworkingActivitiesTitle': 'Ulepszone aktywności networkingowe',
  'enhancedNetworkingActivitiesDescription': 'Oprócz bezpośrednich połączeń, Hub obejmuje:',

  'topicsToDiscussDescription':
    '<strong>Topics to Discuss:</strong> Przeglądaj tematy, które cię interesują i połącz się z autorami lub uczestnikami. Dołącz do dyskusji online lub zaplanuj spotkania grupowe, aby głębiej porozmawiać na te tematy.',
  'oneOnOneMeetingPlannerDescription':
    '<strong>1:1 Meeting Planner:</strong> Zarządzaj zapytaniami o spotkania, śledź zaplanowane spotkania i łatwo organizuj swój harmonogram.',

  'gamificationTitle': 'Gamifikacja dla zabawy i zaangażowania',
  'gamificationDescription':
    'Zwiększ swoją aktywność na liście liderów, która śledzi twoje punkty i wyświetla najbardziej aktywnych networkerów. Oto jak możesz zdobywać punkty:',

  'pointsSystem': {
    points1000ProfileComplete: '<strong>1.000 punktów:</strong> Uzupełnij swój profil (w tym zdjęcie).',
    points1000PushNotifications: '<strong>1.000 punktów:</strong> Włącz powiadomienia push.',
    points100SendMeetingRequest: '<strong>100 punktów:</strong> Wyślij zapytanie o spotkanie 1:1.',
    points400GetAcceptedRequest: '<strong>400 punktów:</strong> Otrzymaj akceptację zapytania o spotkanie 1:1.',
    points400AcceptRequest: '<strong>400 punktów:</strong> Zaakceptuj zapytanie o spotkanie 1:1.',
    points100DeclineRequest: '<strong>100 punktów:</strong> Odrzuć zapytanie o spotkanie 1:1.',
    points400CreateDiscussion: '<strong>400 punktów:</strong> Stwórz temat do dyskusji.',
    points50LikeDiscussion: '<strong>50 punktów:</strong> Polub temat dyskusji.',
    points200PostFirstComment: '<strong>200 punktów:</strong> Za każdym razem, gdy dodasz swój pierwszy komentarz w innym temacie.',
    points100LikeOnTopic: '<strong>100 punktów:</strong> Zdobyj polubienie swojego tematu.',
    points200UniqueCommenter: '<strong>200 punktów:</strong> Zdobądź unikalnego komentatora w swoim temacie.',
    points100LikeShortlistUser: '<strong>100 punktów:</strong> Polub/wybierz użytkownika (dodaj do swojej krótkiej listy).',
    points50SkipUser: '<strong>50 punktów:</strong> Pomiń użytkownika.',
    points200StartChat: '<strong>200 punktów:</strong> Rozpocznij czat (skontaktowany).',
    points300GetChatResponse: '<strong>300 punktów:</strong> Otrzymaj odpowiedź w czacie (połączony).',
    points400RespondToChat: '<strong>400 punktów:</strong> Odpowiedz na zapytanie o czat (połączony).',
    points500SpeedNetworking: '<strong>500 punktów:</strong> Za każdą sesję szybkiego networkingu.'
  },

  'finalMessage':
    'Wykorzystaj w pełni Networking Hub, odkrywaj nowe możliwości i awansuj na liście liderów, łącząc się i angażując z profesjonalistami o podobnych zainteresowaniach!',

  'manageMeeting': 'Zarządzaj spotkaniem',
  'addToCalendar': 'Dodaj do kalendarza',
  'cancel': 'Anuluj',
  'accept': 'Zaakceptuj',
  'accept&addToCalendar': 'Zaakceptuj i dodaj do kalendarza',
  'editDetails': 'Edytuj szczegóły',
  'reject': 'Odrzuć',
  'delete': 'Usuń',
  'exportContact': 'Eksportuj kontakt',
  'scheduleNewOneOnOne': 'Zaplanuj nowe 1:1',
  'initiatedBy': 'Zainicjowane przez',
  'rejectedBy': 'Odrzucone przez',
  'you': 'ty',
  'meetPassed': 'Spotkanie się odbyło',
  'meetInProgress': 'W trakcie',

  'myOneOnOne': 'Mój 1:1',

  'speed': {
    history: 'Historia',
    minutes: 'min.',
    users_available: 'dostępni',
    rules: 'Zasady',
    activate: 'Aktywuj',
    matching: 'Dopasowywanie...',
    start: 'Start',
    find_a_user: 'Znajdź użytkownika z tym samym obrazem',
    find_a_user_number: 'Znajdź użytkownika z tym samym numerem',
    waiting: 'Oczekiwanie...',
    speaking_now: 'Teraz mówi',
    networking_topics: 'Tematy sieciowe',
    session_ended: 'Sesja zakończona',
    find_next_partner: 'Znajdź kolejnego partnera',
    find_next_group: 'Znajdź następną grupę',
    partner_wasnt_ready: 'Partner nie był gotowy',
    partner_wasnt_ready_description: 'Wygląda na to, że partner nie był gotowy do dyskusji. Znajdźmy nowego!',
    start_matching: 'Rozpocznij dopasowywanie'
  }
}
